import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as ShopIcon} from "assets/img/shop.svg";
import {ReactComponent as ShopIconSelected} from "assets/img/shop-selected.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";


function RetailersItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_RETAILER_VIEW)
        && !hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT)
    ) {
        return null;
    }

    const selected = currentPath.startsWith('/retailers/order'); // TODO handle this path in MarketplaceRoutes

    return (
        <SidebarItem
            isTopLevel
            icon={selected ? <ShopIconSelected /> : <ShopIcon />}
            to={MarketplaceRoutes.RETAILERS_LIST}
            selected={selected}
        >
            <FormattedMessage id={'sidebar.item.retailers'} />
        </SidebarItem>
    );
}

export default RetailersItem;
